const GET_COMPETITION = 'GET_COMPETITION';
const FETCH_COMPETITION = 'FETCH_COMPETITION';
const REMOVE_DATA = 'REMOVE_DATA';
const SET_DATA = 'SET_DATA';
const SET_LINK = 'SET_LINK';
const UPDATE_COMPETITION = 'UPDATE_COMPETITION';
const CREATE_NEW_COMPETITION = 'CREATE_NEW_COMPETITION';
const FETCH_COMPETITIONS_FOR_SELECTOR = 'FETCH_COMPETITIONS_FOR_SELECTOR';
const GET_COMPETITION_BY_ID = 'GET_COMPETITION_BY_ID';
const FULL_UPDATE_COMPETITION = 'FULL_UPDATE_COMPETITION';
const DELETE_COMPETITION = 'DELETE_COMPETITION';
const GET_COMP_LINKS = 'GET_COMP_LINKS';

export default {
	GET_COMPETITION,
	FETCH_COMPETITION,
	REMOVE_DATA,
	SET_DATA,
	SET_LINK,
	UPDATE_COMPETITION,
	CREATE_NEW_COMPETITION,
	FETCH_COMPETITIONS_FOR_SELECTOR,
	GET_COMPETITION_BY_ID,
	FULL_UPDATE_COMPETITION,
	DELETE_COMPETITION,
	GET_COMP_LINKS,
};
